module.exports = __webpack_public_path__ + "static/img/theme_3.4f3ad8c8.png";